import React, { useState, useEffect, useRef } from 'react';

// material ui
import Typography from '@material-ui/core/Typography';
import Grid from '@material-ui/core/Grid';
import FormControl from '@material-ui/core/FormControl';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import FormHelperText from '@material-ui/core/FormHelperText';
import RadioGroup from '@material-ui/core/RadioGroup';
import Radio from '@material-ui/core/Radio';

import MenuItem from '@material-ui/core/MenuItem';
import Select from '@material-ui/core/Select';
import { generateYears, generateMonths } from '../../../../../utils/generator';

import useStyles from './styles';

import Button from '@material-ui/core/Button';
import CircularProgress from '@material-ui/core/CircularProgress';
import ChevronRight from '@material-ui/icons/ChevronRight';
import ChevronLeft from '@material-ui/icons/ChevronLeft';
import InfoButton from '../../../../../components/InfoButton';

var d = new Date();
var n = d.getFullYear();
const years = generateYears(n - 25);
const months = generateMonths();


function SubForm03({ id, setValue, saveValue, saveValueJump, value, kb, handleNextSub, no_kk, navigationMode, handleBackSub, isSubmitting, setKB }) {

    const nextRef = useRef(null);
    const backRef = useRef(null);

    const classes = useStyles();
    const [error, setError] = useState({});
    const [notPregnant, setNotPregnant] = useState(false);

    const [kontrasepsi, setKontrasepsi] = useState(value.menggunakan_kontrasepsi || '')
    const [bulanPakai, setBulanPakai] = useState(value.bulan_pakai || '')
    const [tahunPakai, setTahunPakai] = useState(value.tahun_pakai || '')
    const [optBulan, setOptBulan] = useState(months)

    const pertanyaan = "Apakah saat ini Ibu atau Suami menggunakan alat/obat/cara kontrasepsi?";

    useEffect(() => {
        
            let Jawaban_D1 = bulanPakai || 0;
            let Jawaban_D2 = tahunPakai || 0;

            if (kontrasepsi == 2) {
                Jawaban_D1 = 0
                Jawaban_D2 = 0
            }

            let normalizeValue = {
                _id: `${no_kk}${id}`,
                Pertanyaan: pertanyaan,
                Jawaban_H1: 0,
                Jawaban_H2: 0,
                Jawaban_HDate1: "",
                Jawaban_HDate2: "",
                No_Pertanyaan: 3,
                No_KK: no_kk,
                answer: [
                    {
                        _id: `${no_kk}${id}01`,
                        No_Jawaban: kontrasepsi,
                        Jawaban_D1,
                        Jawaban_D2,
                        Jawab_D3: 0,
                        Jawab_D4: 0,
                        pilihankb: 0,
                        Lainnya: ""
                    }
                ]
            }

            if (value._rev) {
                normalizeValue._rev = value._rev
            }

            saveValueJump(normalizeValue)

    }, [kontrasepsi, bulanPakai, tahunPakai])

    useEffect(() => {
        setError({})

        // if (kb["0103"].sedang_hamil === "2") {
        //     setNotPregnant(true);
        // } else {
        //     if (navigationMode === 'back') {
        //         handleBackSub();
        //     } else {
        //         handleNextSub()
        //     }
        // }
        /* cek kondisi untuk semua form */
        if (kb["0102"].sedang_hamil === "2" && kb["0103"].menggunakan_kontrasepsi === "2" && kb["0104"].pernah_menggunakan_kontrasepsi === "1") {
            setNotPregnant(true);
        } else {
            if (kb["0102"].sedang_hamil === "1") {

                let normalizeValue = {}

                setKB({
                    ...kb,
                    [id]: {
                        ...kb[id],
                        ["menggunakan_kontrasepsi"]: undefined
                    }
                })

                if (navigationMode === 'back') {
                    handleBackSub();
                } else {
                    saveValueJump(normalizeValue)
                    handleNextSub()
                }


            } else {
                setNotPregnant(true);
            }
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [])

    if (!notPregnant) {
        return null
    }

    const handleChange = (e) => {

        if(e.target.name === 'menggunakan_kontrasepsi'){
            value.bulan_pakai = null;
            setBulanPakai(null);
            value.tahun_pakai = null;
            setTahunPakai(null);
        }

        setValue(e)

        if(new Date().getFullYear() === +tahunPakai && e.target.name !== "tahun_pakai" || 
        (e.target.name === "tahun_pakai" && new Date().getFullYear() === +e.target.value)){
            setOptBulan(
                months.filter(month => month <= new Date().getMonth())
            )
        }else{
            setOptBulan(months)
        }

        setError({
            ...error,
            [e.target.name]: ""
        })

        switch (e.target.name) {
            case 'menggunakan_kontrasepsi':
            setKontrasepsi(e.target.value)
            break;
            case 'bulan_pakai':
            setBulanPakai(e.target.value)
            break;
            case 'tahun_pakai':
            setTahunPakai(e.target.value)
            break;
            default:
                break;
        }
        // setSomethingChange(true)
    }
    
    //action save onchange
    

    const validate = () => {
        let newError = {};

        if (!value.menggunakan_kontrasepsi) {
            newError.menggunakan_kontrasepsi = "Wajib diisi";
        }

        if (value.menggunakan_kontrasepsi === "1") {
            if (!value.bulan_pakai) {
                newError.bulan_pakai = "Bulan wajib diisi";
            }

            if (value.tahun_pakai === new Date().getFullYear()) {
                if (value.bulan_pakai > new Date().getMonth() + 1) {
                    newError.bulan_pakai = "Bulan pakai tidak boleh lebih dari bulan dan tahun saat ini";
                }
            }

            if (!value.tahun_pakai) {
                newError.tahun_pakai = "Tahun wajib diisi";
            }
        }
        return newError;
    }
    
    const handleSubmit = (e) => {
        e.preventDefault()
        const findErrors = validate();

        const errorValues = Object.values(findErrors);

        if (errorValues.length > 0 && errorValues.some(err => err !== '')) {
            setError(findErrors);
        } else {

            // const normalizeValue = {
            //     pertanyaan,
            //     jawaban_1: value.menggunakan_kontrasepsi,

            // }

            let Jawaban_D1 = value.bulan_pakai || 0;
            let Jawaban_D2 = value.tahun_pakai || 0;

            let normalizeValue = {
                _id: `${no_kk}${id}`,
                Pertanyaan: pertanyaan,
                Jawaban_H1: 0,
                Jawaban_H2: 0,
                Jawaban_HDate1: "",
                Jawaban_HDate2: "",
                No_Pertanyaan: 3,
                No_KK: no_kk,
                answer: [
                    {
                        _id: `${no_kk}${id}01`,
                        No_Jawaban: value.menggunakan_kontrasepsi,
                        Jawaban_D1,
                        Jawaban_D2,
                        Jawab_D3: 0,
                        Jawab_D4: 0,
                        pilihankb: 0,
                        Lainnya: ""
                    }

                ]


            }

            if (value._rev) {
                normalizeValue._rev = value._rev
            }

            saveValue(normalizeValue)
        }
    }

    return (
    <>
    <form id={id} onSubmit={handleSubmit} noValidate>
        <div className={classes.card}>
            <div className={classes.cardHeader}>
                <Typography margin="normal" paragraph>
                    <span className={classes.badge}>03</span>Apakah <strong>saat ini</strong> Ibu atau Suami menggunakan alat/obat/cara kontrasepsi?</Typography>
                <div style={{ position: "absolute", right: "0", top: "58px" }}>
                    <InfoButton
                        content={
                            "Kapan mulai menggunakan alat/obat/cara KB (kontrasepsi) tanpa diselingi kehamilan." +
                            "\nJika diselingi kehamilan, maka kapan mulai pastikan tidak lebih lama dari bulan dan tahun lahir anak kandung terakhir."+
                            "\nJika responden lupa kapan mulai, kaitkan dengan peristiwa penting seperti tanggal lahir anak terakhir."
                        }
                    />
                </div>
            </div>
            <div className={classes.cardBody}>
                <Grid container spacing={1}>
                    <Grid item xs={12} md={4}>
                        <FormControl
                            error={error.menggunakan_kontrasepsi ? true : false}
                            component="fieldset">
                            <RadioGroup value={value.menggunakan_kontrasepsi || ''}
                                onChange={handleChange}
                                aria-label="menggunakan_kontrasepsi" name="menggunakan_kontrasepsi">
                                <FormControlLabel control={<Radio />}
                                    value="1"
                                    label="1. Ya" />
                                <FormControlLabel control={<Radio />}
                                    value="2"
                                    label="2. Tidak" />
                            </RadioGroup>
                            <FormHelperText>{error.menggunakan_kontrasepsi}</FormHelperText>
                        </FormControl>
                    </Grid>
                    {value.menggunakan_kontrasepsi === '1' &&
                        <>
                            <Grid item xs={12}>
                                <Typography>Kapan mulai menggunakan alat/obat KB (Kontrasepsi) yang dipakai saat ini?</Typography>
                            </Grid>
                            <Grid item xs={6} md={3}>

                                <FormControl

                                    variant="outlined"
                                    fullWidth
                                    error={error.bulan_pakai ? true : false}>

                                    <Select
                                        id="bulan_pakai"
                                        value={value.bulan_pakai || ''}
                                        onChange={handleChange}
                                        name="bulan_pakai"
                                        displayEmpty
                                    >
                                        <MenuItem value="">Bulan</MenuItem>
                                        {optBulan.map(month => <MenuItem key={month} value={month}>{month}</MenuItem>)}
                                    </Select>
                                    <FormHelperText>{error.bulan_pakai}</FormHelperText>
                                </FormControl>
                            </Grid>
                            <Grid item xs={6} md={3}>

                                <FormControl

                                    variant="outlined"
                                    fullWidth
                                    error={error.tahun_pakai ? true : false}>

                                    <Select
                                        id="tahun_mulai"
                                        value={value.tahun_pakai || ''}
                                        onChange={handleChange}
                                        name="tahun_pakai"
                                        displayEmpty
                                    >
                                        <MenuItem value="">Tahun</MenuItem>
                                        {years.map(year => <MenuItem key={year} value={year}>{year}</MenuItem>)}
                                    </Select>
                                    <FormHelperText>{error.tahun_mulai}</FormHelperText>
                                </FormControl>
                            </Grid>
                        </>
                    }


                </Grid>
            </div>
        </div>
    </form>

    <Grid item xs style={{marginTop:20}}>
        <Button
            ref={backRef}
            // disabled={!isSomethingChange || isSubmitting}
            onClick={handleBackSub}><ChevronLeft className={classes.iconLeft} /> Sebelumnya </Button>

        {isSubmitting && <CircularProgress size={14} />}
        <Button
            style={{float: 'right'}}
            ref={nextRef}
            form={id}
            disabled={isSubmitting}
            type="submit">Selanjutnya <ChevronRight className={classes.iconRight} /></Button>
    </Grid>
    </>
    )
}

export default SubForm03;